import React, { FC } from 'react';
import { HeadingBlock } from '@design-system/heading-block';
import { Image } from '@design-system/image';
import { Link } from '@design-system/link';
import { Typography } from '@design-system/typography';
import cx from 'classnames';

import { ICarouselSlide } from './models';

const CarouselSlide: FC<ICarouselSlide> = ({
  heading,
  subHeading,
  description,
  image,
  disclaimer,
  button,
  icons,
  backgroundColor,
  customTitle,
}) => (
  <div className={cx('custom-tabs__slide', `custom-tabs__slide--${backgroundColor}`)}>
    <div className="custom-tabs__slide-content-with-image">
      <Image src={image.src} alt={image.altText} className="custom-tabs__slide-image" />
      <div className="custom-tabs__slide-content">
        <HeadingBlock
          className="custom-tabs__slide-subheading"
          align="center"
          headline={subHeading}
          headlineTag="h4"
          headlineSize="l"
          headlineWeight="bold"
        />
        <HeadingBlock
          className={cx('custom-tabs__slide-heading', {
            'custom-tabs__slide-heading--adult': customTitle,
          })}
          align="center"
          headline={heading}
          headlineTag="h3"
          headlineSize="xxl"
          headlineWeight="bold"
        />
        <Typography
          className="custom-tabs__slide-description"
          tag="p"
          align="center"
          variant="detail"
          size="xxl"
          weight="medium"
          content={description}
        />

        <div className="custom-tabs__slide-icons-wrapper">
          {icons.map(({ image: iconImage, heading: iconHeading }) => (
            <div key={heading + iconImage.src} className="custom-tabs__slide-icon-wrapper">
              <Image
                src={iconImage.src}
                alt={iconImage.altText}
                className="custom-tabs__slide-icon"
              />
              <Typography
                className="custom-tabs__slide-icon-heading"
                tag="p"
                align="center"
                variant="detail"
                size="xxl"
                weight="bold"
                content={iconHeading}
              />
            </div>
          ))}
        </div>
        <Link
          variant="primary"
          title={button.label}
          aria-label="large"
          className={`custom-tabs__slide-btn custom-tabs__slide-btn--${backgroundColor}`}
          href={button.link!}
        >
          {button.label}
        </Link>
      </div>
    </div>

    <Typography
      className="custom-tabs__slide-disclaimer"
      tag="p"
      align="center"
      variant="detail"
      size="l"
      weight="regular"
      content={disclaimer}
    />
  </div>
);

export default CarouselSlide;
